import SavingsPolicyOptions from "../datasets/savings_policy_options";
import checkForAutorolloverCDChgs from "./check_for_autorollover_CD_chgs";

export const buildConfirmModalContent = (savingsInfo, CDList) => {
    let totalTransferAmt = 0;
    let totalOneTimeAmt = 0;
    let totalCurrentMonthlyAmt = 0;
    let totalNewMonthlyAmt = 0;
    let CDListArr = [];
    let confirmArr = [];
    let transferFeeSw = false;
    for (let i=0; i<savingsInfo.length; i++){
        const savingsInfoObj = savingsInfo[i];
        const savingsPolicy = SavingsPolicyOptions.find(elem => elem.type === savingsInfoObj.savingsType);
        let savingsTypeText = savingsInfoObj.savingsType;
        if (savingsPolicy){
            savingsTypeText = savingsPolicy.shortName;
        }
        totalOneTimeAmt += +savingsInfoObj.oneTimeDepositAmt;
        const transferAmt = +savingsInfoObj.newTransferAmt - +savingsInfoObj.newTransferFee;
        totalTransferAmt += +transferAmt;
        let transferFee = false;
        if (+savingsInfoObj.newTransferFee !== 0){
            transferFee = true;
            transferFeeSw = true;
        }
        totalCurrentMonthlyAmt += +savingsInfoObj.currentMonthlyAmt;
        totalNewMonthlyAmt += +savingsInfoObj.monthlyDepositAmt;
        let rowClass = "";
        if (savingsInfoObj.updated === true){
            if (savingsInfoObj.savingsType === "CD"){
                CDListArr = checkForAutorolloverCDChgs(CDList);  
                //  note that for CDs the dataUpdated flag may be due to change in autoRollover
                if (+savingsInfoObj.oneTimeDepositAmt > 0 ||
                    +savingsInfoObj.currentMonthlyAmt !== +savingsInfoObj.monthlyDepositAmt ||
                    +savingsInfoObj.newTransferAmt > 0){
                        rowClass = "myTable-row-highlight";
                }
            }else{
                rowClass = "myTable-row-highlight";
            }
        }
        const confirmObj = {savingsType: savingsTypeText,
            oneTimeAmt: savingsInfoObj.oneTimeDepositAmt,
            transferAmt: transferAmt,
            transferFee: transferFee,
            currentMonthlyAmt: +savingsInfoObj.currentMonthlyAmt,
            newMonthlyAmt: +savingsInfoObj.monthlyDepositAmt,
            percent: 0,
            rowClass: rowClass
        }
        confirmArr.push(confirmObj);
    }
    const confirmObj = {savingsType: "Total Amounts", 
        oneTimeAmt: totalOneTimeAmt,
        transferAmt: totalTransferAmt,
        transferFee: false,
        currentMonthlyAmt: totalCurrentMonthlyAmt,
        newMonthlyAmt: totalNewMonthlyAmt,
        percent: 100,
        rowClass: "font-weight-bold"
    }
    confirmArr.push(confirmObj);
    let returnObj = {confirmArr: confirmArr, CDListArr: CDListArr, totalNewMonthlyAmt: totalNewMonthlyAmt,
        transferFeeSw: transferFeeSw }
    return returnObj;
}
export default buildConfirmModalContent;